"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINTable = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var react_1 = require("@iconify/react");
var utilities_1 = require("../../utilities");
var PINTable = /** @class */ (function (_super) {
    __extends(PINTable, _super);
    function PINTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            sort: {
                index: null,
                isAscending: null
            },
            isLastChildVisible: false
        };
        _this.checkScrollForSize = function () {
            // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
            if (_this.dataElem.parentElement.offsetWidth < (_this.props.minWidth || 0)) {
                // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                _this.dataElem.parentElement.style.overflowX = "scroll";
            }
            else {
                // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                _this.dataElem.parentElement.scrollLeft = 0;
                // @ts-expect-error ts-migrate(2531) FIXME: Object is possibly 'null'.
                _this.dataElem.parentElement.style.overflowX = "initial";
            }
        };
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'index' implicitly has an 'any' type.
        _this.filterSelection = function (index) {
            if (!_this.props.structure[index].sort) {
                return;
            }
            var isAscendingDefault = _this.props.structure[index].sort.toLowerCase() !== "dsc";
            _this.setState(function () { return ({
                sort: {
                    index: index,
                    isAscending: _this.state.sort.index === index
                        ? !_this.state.sort.isAscending : isAscendingDefault
                }
            }); }, function () {
                if (!_this.props.onSortChange) {
                    return;
                }
                _this.props.onSortChange(_this.props.structure[index], _this.state.sort.isAscending);
            });
        };
        _this.onScroll = function () {
            if (_this.props.onScroll) {
                _this.props.onScroll(_this.dataElem.scrollTop);
            }
            if (!_this.lastRow) {
                return;
            }
            var rect = _this.lastRow.getBoundingClientRect();
            var height = (window.innerHeight || document.documentElement.clientHeight);
            var width = (window.innerWidth || document.documentElement.clientWidth);
            var isLastChildVisible = (
            /* Full height in window, but not necesseraly full width */
            rect.top >= 0 && rect.left >= 0 && rect.bottom <= height && rect.left <= width);
            if (isLastChildVisible !== _this.state.isLastChildVisible) {
                _this.setState(function () { return ({ isLastChildVisible: isLastChildVisible }); });
                if (isLastChildVisible && _this.props.onBottomReach) {
                    _this.props.onBottomReach();
                }
            }
        };
        return _this;
    }
    PINTable.prototype.UNSAFE_componentWillMount = function () {
        var _this = this;
        if (this.props.defaultSort) {
            // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'column' implicitly has an 'any' type.
            this.props.structure.forEach(function (column, index) {
                if (column.key === _this.props.defaultSort.key) {
                    _this.setState(function () { return ({
                        sort: {
                            index: index,
                            isAscending: _this.props.defaultSort.isAscending
                        }
                    }); });
                }
            });
        }
    };
    PINTable.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this.onScroll, false);
        window.addEventListener("resize", this.checkScrollForSize);
        this.dataElem.addEventListener("scroll", this.onScroll, false);
        if (this.props.scrollStartPosition) {
            this.dataElem.scrollTop = this.props.scrollStartPosition;
        }
        this.checkScrollForSize();
    };
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'prevProps' implicitly has an 'any' type... Remove this comment to see the full error message
    PINTable.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.scrollStartPosition === this.props.scrollStartPosition) {
            return;
        }
        this.dataElem.scrollTop = this.props.scrollStartPosition;
    };
    PINTable.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.checkScrollForSize);
        window.removeEventListener("scroll", this.onScroll, false);
        this.dataElem.removeEventListener("scroll", this.onScroll, false);
    };
    PINTable.prototype.render = function () {
        var _this = this;
        var _a = this.props, className = _a.className, dataClass = _a.dataClass, bordered = _a.bordered, structure = _a.structure, data = _a.data, isLoading = _a.isLoading, minWidth = _a.minWidth;
        // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'acc' implicitly has an 'any' type.
        var needHeader = structure.reduce(function (acc, value) { return (acc || Boolean(value.title)); }, false);
        var sort = this.state.sort;
        return (React.createElement("div", { className: "pintable " + (className || "") + (bordered ? " bordered" : "") },
            needHeader
                && React.createElement("div", { className: "pintable-header", style: { minWidth: (minWidth || 0) + "px" } }, structure.map(function (column, index) { return (React.createElement("div", { key: column.key, className: "pintable-header-column" + (column.sort ? " sortable" : "") + (sort.index === index ? " sorted" : "") + (sort.index === index && sort.isAscending ? " asc" : ""), style: column.fixedSize
                        ? { width: column.fixedSize } : { flex: column.size || 1 }, onClick: function () { return _this.filterSelection(index); } },
                    React.createElement("span", null, column.title),
                    Boolean(column.sort)
                        && React.createElement(react_1.Icon, { className: "pintable-header-column-icon", color: sort.index === index ? utilities_1.Colors.coal : utilities_1.Colors.silver, icon: "mdi:chevron-down", style: { fontSize: "2rem" } }))); })),
            React.createElement("ul", { className: "pintable-data " + (dataClass || ""), 
                // @ts-expect-error ts-migrate(2322) FIXME: Type 'HTMLUListElement | null' is not assignable t... Remove this comment to see the full error message
                ref: function (e) { _this.dataElem = e; }, style: { minWidth: (minWidth || 0) + 8 + "px" } },
                Boolean(this.props.headerView)
                    && React.createElement("li", { className: "pintable-data-header-view" }, this.props.headerView),
                Boolean(data) && data.map(function (row, index) { return (React.createElement("li", { key: index + "row", className: "pintable-row" + (row.url ? " linked" : ""), onClick: function () { return (row.url ? _this.props.routingFunction(row.url) : null); }, 
                    // @ts-expect-error ts-migrate(2322) FIXME: Type 'HTMLLIElement | null' is not assignable to t... Remove this comment to see the full error message
                    ref: function (e) { _this.lastRow = e; } },
                    React.createElement("div", { className: "pintable-row-wrapper" + (row.autoHeight ? " auto-height" : "") }, structure.map(function (column) { return (React.createElement("div", { key: column.key + index, className: "pintable-row-column ck_" + column.key, style: column.fixedSize
                            ? { width: column.fixedSize } : { flex: column.size || 1 } }, row[column.key])); })))); }),
                isLoading && Boolean(this.props.loadingView)
                    && React.createElement("li", { className: "pintable-data-loading-view" }, this.props.loadingView),
                Boolean(this.props.footerView)
                    && React.createElement("li", { className: "pintable-data-footer-view" }, this.props.footerView))));
    };
    PINTable.propTypes = {
        structure: PropTypes.arrayOf(PropTypes.shape({
            title: PropTypes.string,
            key: PropTypes.string.isRequired,
            size: PropTypes.number,
            fixedSize: PropTypes.string,
            sort: PropTypes.string
        })).isRequired,
        /**
         * The data to display. Every key who doesn't match a structure specified key will be ignore,
         * except `url` who make the row clickable to the url and `autoHeight` who allow the cell to exceed the fixed
         * height to display all its content.
         *
         */
        data: PropTypes.arrayOf(PropTypes.object),
        bordered: PropTypes.bool,
        isLoading: PropTypes.bool,
        defaultSort: PropTypes.shape({
            key: PropTypes.string,
            isAscending: PropTypes.bool
        }),
        onSortChange: PropTypes.func,
        onBottomReach: PropTypes.func,
        onScroll: PropTypes.func,
        scrollStartPosition: PropTypes.number,
        headerView: PropTypes.element,
        footerView: PropTypes.element,
        loadingView: PropTypes.element,
        minWidth: PropTypes.number
    };
    return PINTable;
}(React.Component));
exports.PINTable = PINTable;
//# sourceMappingURL=PINTable.js.map